import { connect } from 'react-redux';

import { initializeBalance, updateLatestTask } from '../actions/actions';
import {
  deleteBookingEntry,
  loadBookingEntries,
} from '../actions/booking-entry-actions';
import { deleteInvoice } from '../actions/invoice-actions';
import BalanceModal from './BalanceModal';

export default connect(
  ({ balance }, props) => ({
    invoices: balance.invoices,
    bookingEntries: balance.bookingEntries,
    initialized: balance.context.opportunityId === props.opportunity.id,
    loading: balance.loading,
    latestTask: balance.context.latestTask,
  }),
  {
    onInitialize: initializeBalance,
    onDeleteBookingEntry: deleteBookingEntry,
    onDeleteInvoice: deleteInvoice,
    onUpdateLatestTask: updateLatestTask,
    onReloadBookingEntries: loadBookingEntries,
  },
)(BalanceModal);
